import {z} from "zod";
import {logoSchema, mediaSchema} from "./shared";

export enum ProjectTypes {
    MobileApp = "Mobile App",
    WebApp = "Web App",
    Website = "Website",
}

export const projectSchema = z.object({
    title: z.string(),
    description: z.string(),
    link: z.string().url().optional(),
    logo: logoSchema.optional(),
    year: z.number().min(1900).max(2100),
    type: z.nativeEnum(ProjectTypes),
    discontinued: z.boolean().optional(),
    cta: z.string().optional(),
    technologies: z.array(z.string()).optional(),
    highlight: z.string().optional(),
    media: mediaSchema,
});

export type Project = z.infer<typeof projectSchema>;